import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { WEB_URL } from '~constant/env';
import getOneIdUrl, { OneIdUrlParams } from '~utils/common/getOneIdUrl';

/**
 * One ID로 페이지 이동 hooks
 * @example 
 * ```typescript
  const moveOneIdPage = useMoveOneIdPage();

  return (
    <a onClick={() => moveOneIdPage()}>로그인</a>
  )
 * ```
 * @returns function
 */
export default function useMoveOneIdPage() {
  const router = useRouter();

  const moveOneIdPage = useCallback(
    (params?: OneIdUrlParams) => {
      if (!router.isReady) {
        return false;
      }

      const url = getOneIdUrl({
        beforeUrl: `${WEB_URL}${encodeURIComponent(router.asPath)}`,
        ...params,
      });

      router.push(url);
    },
    [router.isReady],
  );

  return moveOneIdPage;
}
